<template>
  <ais-sort-by :items="sortByOptions">
    <template #default="{ items, currentRefinement, refine }">
      <a
        class="dropdown-toggle nav-underline text-black"
        data-bs-toggle="dropdown"
        href="#"
        role="button"
        aria-haspopup="true"
        aria-expanded="false"
      >
        {{ gettext('Sorteer') }}<span class="caret"></span>
      </a>
      <div class="dropdown-menu dropdown-menu-right">
        <a
          v-for="item in items"
          :key="item.value"
          href="#"
          :class="{
            'dropdown-item': true,
            active: item.value === currentRefinement,
          }"
          @click.prevent="refine(item.value)"
        >
          {{ item.label }}
        </a>
      </div>
    </template>
  </ais-sort-by>
</template>

<script>
import { AisSortBy } from 'vue-instantsearch';
import SortBy from '../mixins/SortBy';

export default {
  components: {
    AisSortBy,
  },
  mixins: [SortBy],
};
</script>
